import { z } from "zod";
import {
  ControlDataTypeKey,
  Types,
  Schema
} from "../prop-controllers";
import { lengthDataSchema } from "../data";
import { match } from "ts-pattern";
const borderRadiusDataSchema = z.object({
  borderTopLeftRadius: lengthDataSchema.nullable().optional(),
  borderTopRightRadius: lengthDataSchema.nullable().optional(),
  borderBottomLeftRadius: lengthDataSchema.nullable().optional(),
  borderBottomRightRadius: lengthDataSchema.nullable().optional()
});
const responsiveBorderRadiusDataSchema = Schema.responsiveValue(
  borderRadiusDataSchema
);
const borderRadiusPropControllerDataV0Schema = responsiveBorderRadiusDataSchema;
const BorderRadiusPropControllerDataV1Type = "prop-controllers::border-radius::v1";
const borderRadiusPropControllerDataV1Schema = z.object({
  [ControlDataTypeKey]: z.literal(BorderRadiusPropControllerDataV1Type),
  value: responsiveBorderRadiusDataSchema
});
const borderRadiusPropControllerDataSchema = z.union([
  borderRadiusPropControllerDataV0Schema,
  borderRadiusPropControllerDataV1Schema
]);
const BorderRadiusPropControllerFormat = {
  ClassName: "makeswift::prop-controllers::border-radius::format::class-name",
  ResponsiveValue: "makeswift::prop-controllers::border-radius::format::responsive-value"
};
function BorderRadius(options = {}) {
  return { type: Types.BorderRadius, version: 1, options };
}
BorderRadius.Format = BorderRadiusPropControllerFormat;
function getBorderRadiusPropControllerDataResponsiveBorderRadiusData(data) {
  return match(data).with(
    { [ControlDataTypeKey]: BorderRadiusPropControllerDataV1Type },
    (v1) => v1.value
  ).otherwise((v0) => v0);
}
function createBorderRadiusPropControllerDataFromResponsiveBorderRadiusData(definition, responsiveBorderRadiusData) {
  return match(definition).with(
    { version: 1 },
    () => ({
      [ControlDataTypeKey]: BorderRadiusPropControllerDataV1Type,
      value: responsiveBorderRadiusData
    })
  ).otherwise(() => responsiveBorderRadiusData);
}
export {
  BorderRadius,
  BorderRadiusPropControllerFormat,
  borderRadiusPropControllerDataSchema,
  createBorderRadiusPropControllerDataFromResponsiveBorderRadiusData,
  getBorderRadiusPropControllerDataResponsiveBorderRadiusData
};
//# sourceMappingURL=border-radius.js.map